import React, { useEffect, useState } from 'react';
import NavBar from '../../components/Navbar/NavBar';
import Footer from '../../components/Footer';
import Card from '../../components/Cards/Card';
import SideMenu from '../../components/SideMenu';
import useDocTitle from '../../utils/useDocTitle';
import api from '../../utils/api.js';
import { useLanguage } from '../../context/LanguageContext';

const ArtisticProgram = () => {
  const { language } = useLanguage(); // Use language context
  useDocTitle(language === 'English' ? 'Artistic Programs' : 'Programet Artistike');

  const [mainPageData, setMainPageData] = useState(null);
  const [audioDescriptions, setAudioDescriptions] = useState([]);
  const [loading, setLoading] = useState(true);

  const menuItems = [
    { href: '#audiodescriptions', label: language === 'English' ? 'Audio Descriptions' : 'Audio Përshkrimet' },
    { href: '#exhibitions', label: language === 'English' ? 'Exhibitions' : 'Ekspozitat' },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const mainPageResponse = await api.get('/artistic_programs');
        const mainData = mainPageResponse.data.find(
          (data) =>
            data.title.rendered ===
            (language === 'English' ? 'Artistic Programs' : 'Programet Artistike')
        );

        if (mainData) {
          setMainPageData({
            title: mainData.title.rendered,
            mainText: mainData.main_text || '',
            mainImage: mainData.main_image?.guid || '/path/to/default-background.jpg',
            mainImageAlt: mainData.main_image?.post_excerpt,
          });
        }

        const audioDescriptionsResponse = await api.get('/audiodescriptions');
        const filteredAudioDescriptions = audioDescriptionsResponse.data.filter(
          (desc) => desc.page_language[0].name === language
        );

        setAudioDescriptions(filteredAudioDescriptions);
      } catch (error) {
        console.error('Error fetching artistic programs:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [language]);

  if (loading) {
    return <div>{language === 'English' ? 'Loading...' : 'Duke u ngarkuar...'}</div>;
  }

  return (
    <>
      <NavBar />

      {mainPageData && (
        <div
          className="relative w-full h-96 bg-cover bg-center flex items-center justify-center"
          style={{
            backgroundImage: `url(${mainPageData.mainImage})`,
            height: '550px'
          }}
        >
          <div className="absolute inset-0 bg-black opacity-60"></div>
          <div className="relative z-10 text-center text-white px-4">
            <h1 className="text-5xl font-bold" tabIndex="0">
              {mainPageData.title}
            </h1>
            <p className="mt-4 text-lg">{mainPageData.mainText}</p>
          </div>
        </div>
      )}

      <div className="flex flex-col lg:flex-row min-h-screen">
        <aside className="lg:w-1/4 bg-gray-100 p-4 lg:p-8 sticky top-16 lg:h-screen">
          <SideMenu
            backLink="/"
            backText={language === 'English' ? 'MAIN PAGE' : 'FAQJA KRYESORE'}
            menuItems={menuItems}
          />
        </aside>

        <div className="w-full lg:w-3/4 p-4 lg:p-8">
          <section id="audiodescriptions" className="mb-16">
            <h2 className="text-2xl md:text-3xl font-semibold mb-6" tabIndex="0">
              {language === 'English' ? 'Audio Descriptions' : 'Audio Përshkrimet'}
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-8">
              {audioDescriptions.map((desc) => (
                <Card
                  key={desc.id}
                  id={desc.id}
                  title={desc.title.rendered}
                  description={desc.description}
                  imgSrc={desc.card_image?.guid || '/path/to/default-image.jpg'}
                  imgAlt={desc.card_image?.post_excerpt || 'Audio Description image'}
                  linkText={language === 'English' ? 'Learn More' : 'Mëso më shumë'}
                  linkPath={`/resources/audio-description/${desc.id}`}
                  borderColorClass="border-secondary"
                  ariaLabel={
                    language === 'English'
                      ? `Go to Audio Description ${desc.title.rendered}`
                      : `Shko te Audio Përshkrimi ${desc.title.rendered}`
                  }
                />
              ))}
            </div>
          </section>

          <section id="exhibitions" className="mb-16">
            <h2 className="text-2xl md:text-3xl font-semibold mb-6" tabIndex="0">
              {language === 'English' ? 'Exhibitions' : 'Ekspozitat'}
            </h2>
            <p>{language === 'English' ? 'Coming soon...' : 'Së shpejti...'}</p>
          </section>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ArtisticProgram;
